import { render, staticRenderFns } from "./associationDetail.vue?vue&type=template&id=7b962b5a&scoped=true"
import script from "./associationDetail.vue?vue&type=script&lang=js"
export * from "./associationDetail.vue?vue&type=script&lang=js"
import style0 from "./associationDetail.vue?vue&type=style&index=0&id=7b962b5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b962b5a",
  null
  
)

export default component.exports